// Import React
import PropTypes from "prop-types";

// Components
import BenchmarkingCollectionsMiniTable from "./BenchmarkCollectionsMiniTable.components.js";

import {
  truncateString,
  extractYearFromISODateString,
} from "../../helpers/common.functions.js";
import {
  getBenchmarkWithRows,
  deleteBenchmarks,
} from "../../api/benchmarking/BenchmarkingAPI.js";
import BenchmarkingCollectionsShare from "./BenchmarkCollectionsShare.components.js";
import BenchmarkingCollectionsComparisons from "./BenchmarkCollectionsComparisons.components.js";
import isEmpty from "../../validation/is-empty.js";

import { hasRoles } from "../../utils/roles";

import BenchmarkCollectionsSave from "./BenchmarkCollectionsSave.components.js";

import "./BenchmarkCollectionsView.css";

BenchmarkCollectionsView.propTypes = {
  user: PropTypes.object,
  selectedCollection: PropTypes.object,
  setSelectedCollection: PropTypes.func,
  benchmarkCollections: PropTypes.object,
  benchmarking: PropTypes.array,
  setLoadedCollection: PropTypes.func,
  setModal: PropTypes.func,
};

export default function BenchmarkCollectionsView(props) {
  const { user } = props;
  const { benchmarking } = props;
  const { selectedCollection, setSelectedCollection } = props;
  const { benchmarkCollections } = props;
  const { setLoadedCollection } = props;
  const { setModal } = props;

  if (isEmpty(selectedCollection)) {
    return <NoCollectionSelected />;
  }

  return (
    <div className="benchmark-create-load-or-save-modal-right-pane">
      <div className="benchmark-create-load-or-save-modal-list-item-contents">
        <div className="benchmark-create-load-or-save-modal-right-pane-content-container">
          <div className="benchmark-create-load-or-save-modal-right-pane-content-forms">
            <div className="benchmark-create-load-or-save-modal-right-pane-modal-title-container">
              <div className="benchmark-create-load-or-save-modal-right-pane-modal-title">
                <div>{selectedCollection.project_name}</div>
              </div>
              <BenchmarkCollectionsSave
                isCreate={false}
                user={user}
                benchmarkCollections={benchmarkCollections}
                selectedCollection={selectedCollection}
                setSelectedCollection={setSelectedCollection}
              />
            </div>
            <div className="benchmark-create-load-or-save-modal-right-pane-content-form">
              <h1 className="display-4 form-title">
                <i className="far fa-file-alt"></i>
                <span>Report Details</span>
              </h1>
              <div className="benchmark-create-load-or-save-modal-right-pane-content-form-control">
                <div>Project Sector</div>
                <div>{selectedCollection.sector}</div>
              </div>
              <div className="benchmark-create-load-or-save-modal-right-pane-content-form-control">
                <div>Project Subsector</div>
                <div>{truncateString(selectedCollection.sub_sector, 25)}</div>
              </div>
              <div className="benchmark-create-load-or-save-modal-right-pane-content-form-control">
                <div>Project Quality</div>
                <div>{selectedCollection.quality}</div>
              </div>
              <div className="benchmark-create-load-or-save-modal-right-pane-content-form-control">
                <div>Project Type</div>
                <div>{selectedCollection.project_type}</div>
              </div>
              <div className="benchmark-create-load-or-save-modal-right-pane-content-form-control">
                <div>Currency</div>
                <div>{selectedCollection.currency}</div>
              </div>
              <div className="benchmark-create-load-or-save-modal-right-pane-content-form-control">
                <div>Displayed Unit</div>
                <div>{selectedCollection.unitOfMeasure}</div>
              </div>
            </div>
            <div className="benchmark-create-load-or-save-modal-right-pane-content-form">
              <h1 className="display-4 form-title">
                <i className="fas fa-sliders-h"></i>
                <span>Parameters</span>
              </h1>
              <div className="benchmark-create-load-or-save-modal-right-pane-content-form-control">
                <div>Region</div>
                <div>{selectedCollection.region}</div>
              </div>
              <div className="benchmark-create-load-or-save-modal-right-pane-content-form-control">
                <div>Country</div>
                <div>{selectedCollection.country}</div>
              </div>
              <div className="benchmark-create-load-or-save-modal-right-pane-content-form-control">
                <div>City</div>
                <div>{selectedCollection.city}</div>
              </div>
              <div className="benchmark-create-load-or-save-modal-right-pane-content-form-control">
                <div>Escalation Year</div>
                <div>
                  {extractYearFromISODateString(selectedCollection.base_date)}
                </div>
              </div>
              <div className="benchmark-create-load-or-save-modal-right-pane-content-form-control">
                <div>Latitude</div>
                <div>{selectedCollection.lat}</div>
              </div>
              <div className="benchmark-create-load-or-save-modal-right-pane-content-form-control">
                <div>Longitude</div>
                <div>{selectedCollection.lng}</div>
              </div>
            </div>
            <div className="benchmark-create-load-or-save-modal-right-pane-content-form">
              <h1 className="display-4 form-title">
                <i className="fas fa-ruler"></i>
                <span>Metrics</span>
              </h1>
              <p>The following metrics are selected as default:</p>
              <ul className="text-left">
                <li>Total Number of Floors</li>
                <li>Local Region Area</li>
                <li>Total Construction Cost</li>
                <li>Total Project Cost</li>
                <li>Construction Cost per GIA</li>
                <li>Total Building Services Cost per GIA</li>
              </ul>
            </div>
            <div className="benchmark-create-load-or-save-modal-right-pane-content-form grid-full-width">
              <div className="benchmark-create-load-or-save-modal-right-pane-content-form-control">
                <div>Global Benchmarking</div>
                <div>{selectedCollection.currencyFactor ? "On" : "Off"}</div>
              </div>
            </div>
            <div className="benchmark-create-load-or-save-modal-right-pane-content-form grid-full-width">
              <div className="benchmark-create-load-or-save-modal-right-pane-content-form-control">
                <div>Functional Unit Benchmarking</div>
                <div>{selectedCollection.localRegionFactor ? "On" : "Off"}</div>
              </div>
            </div>
            <div className="benchmark-create-load-or-save-modal-right-pane-content-form grid-full-width">
              <div className="benchmark-create-load-or-save-modal-right-pane-content-form-title-button">
                <h1 className="display-4 form-title">
                  <i className="fas fa-tasks" />
                  <span>Selected Projects</span>
                </h1>
                <BenchmarkingCollectionsComparisons
                  user={user}
                  benchmarking={benchmarking}
                  benchmarkCollections={benchmarkCollections}
                  selectedCollection={selectedCollection}
                  setSelectedCollection={setSelectedCollection}
                />
              </div>
              <BenchmarkingCollectionsMiniTable
                selectedCollection={selectedCollection}
                setSelectedCollection={setSelectedCollection}
                benchmarkCollections={benchmarkCollections}
                user={user}
              />
            </div>
          </div>
        </div>
      </div>
      <div className="benchmark-create-load-or-save-modal-footer right-pane">
        <div>
          {hasRoles(user.roles, ["Client"]) ? null : (
            <button
              className="button advice-delete-button "
              onClick={async () => {
                const confirm = window.confirm(
                  "Confirm delete this benchmark collection with id " +
                    selectedCollection.id +
                    "? This cannot be undone."
                );
                if (confirm) {
                  deleteBenchmarks([selectedCollection.id]);
                  benchmarkCollections.set(await benchmarkCollections.get());
                  setSelectedCollection({});
                }
              }}
            >
              <i className="far fa-trash-alt"></i>
            </button>
          )}
        </div>
        <div className="benchmark-create-load-or-save-modal-footer-button-container">
          <BenchmarkingCollectionsShare
            user={user}
            benchmarkCollections={benchmarkCollections}
            selectedCollection={selectedCollection}
            setSelectedCollection={setSelectedCollection}
          />
          <button
            className="button general-modal-button"
            onClick={async () => {
              let collection = await getBenchmarkWithRows(
                selectedCollection.id
              );
              setLoadedCollection(collection?.[0]);
              setModal(false);
            }}
          >
            Load Analysis
          </button>
        </div>
      </div>
    </div>
  );
}

function NoCollectionSelected() {
  return (
    <div className="benchmark-create-load-or-save-modal-right-pane">
      <div className="list-item-information ">
        <i className="fas fa-download fa-10x"></i>
        <div className="text">
          <span>
            Please select a Collection on the left to load the analysis.
          </span>
        </div>
      </div>
      <div className="benchmark-create-load-or-save-modal-footer right-pane">
        <div className="message"></div>
      </div>
    </div>
  );
}
